import { RootState } from '../../../app/reducer';
import { DataState } from '../../../constants';
import { PodcastEpisodeModel, PodcastModel } from '../../../models/Podcast.model';

export const selectPodcastList =
  (tabId: number) =>
  ({ podcastReducer }: RootState): Partial<PodcastModel>[] | null =>
    podcastReducer[tabId]?.data?.podcastList ?? null;

export const selectLatestEpisodes =
  (tabId: number) =>
  ({ podcastReducer }: RootState): PodcastEpisodeModel[] | null =>
    podcastReducer[tabId]?.data?.latestEpisodes ?? null;

export const selectPodcastListAndEpisodesState =
  (tabId: number) =>
  ({ podcastReducer }: RootState): DataState =>
    podcastReducer[tabId]?.state ?? DataState.NOT_LOADED;

export const selectPodcastFeedData =
  (podcastUrl: string) =>
  ({ podcastReducer }: RootState): PodcastModel | null =>
    podcastReducer.podcastFeeds?.[podcastUrl]?.data ?? null;

export const selectPodcastFeedDataState =
  (podcastUrl: string) =>
  ({ podcastReducer }: RootState): DataState =>
    podcastReducer.podcastFeeds?.[podcastUrl]?.state ?? DataState.NOT_LOADED;

export const selectPodcastFeedCurrentPage =
  (podcastUrl: string) =>
  ({ podcastReducer }: RootState): number =>
    podcastReducer.podcastFeeds?.[podcastUrl]?.currentPage ?? 1;

export const selectPodcastFeedLastPage =
  (podcastUrl: string) =>
  ({ podcastReducer }: RootState): number =>
    podcastReducer.podcastFeeds?.[podcastUrl]?.lastPage ?? 1;

export const selectPodcastFeedOrder =
  (podcastUrl: string) =>
  ({ podcastReducer }: RootState): 'desc' | 'asc' =>
    podcastReducer.podcastFeeds?.[podcastUrl]?.order ?? 'desc';
